module.exports = __webpack_public_path__ + "static/media/3-tematicheskie.f7e1000e.jpg";